export default __webpack_public_path__ + "static/media/plat-ben6.95f3fdfa.svg";